export const MAIN_CLASS_NAME = 'project-source-header';
export const BLOCK_CLASS_NAME = `${MAIN_CLASS_NAME}__block`;
export const TYPE_CLASS_NAME = `${BLOCK_CLASS_NAME}_type`;
export const VOLUME_CLASS_NAME = `${BLOCK_CLASS_NAME}_volume`;
export const DATE_CLASS_NAME = `${BLOCK_CLASS_NAME}_date`;
export const STATUS_CLASS_NAME = `${BLOCK_CLASS_NAME}_status`;
export const CONTEXT_CLASS_NAME = `${BLOCK_CLASS_NAME}_context`;
export const SKELETON_CONTAINER_CLASS_NAME = `${MAIN_CLASS_NAME}__skeleton-container`;
export const SKELETON_CLASS_NAME = `${SKELETON_CONTAINER_CLASS_NAME}__skeleton`;

export const SKELETON_HEIGHT = 32;
